/**
 * @generated SignedSource<<0034fdeaf43f49c888b1462ba72d0115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarEventEditScreenQuery$variables = {
  eventId: string;
  widgetId: string;
};
export type WidgetCalendarEventEditScreenQuery$data = {
  readonly store: {
    readonly calendarEvent: {
      readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_event">;
    } | null;
    readonly timezone: string;
  };
  readonly widgetCalendarOverview: {
    readonly calendars: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_storeCalendars">;
    }>;
  } | null;
};
export type WidgetCalendarEventEditScreenQuery = {
  response: WidgetCalendarEventEditScreenQuery$data;
  variables: WidgetCalendarEventEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "includeExternal",
    "value": true
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarEventEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CalendarTeamEventEditScreenComponent_storeCalendars"
              }
            ],
            "storageKey": "calendars(includeExternal:true)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CalendarTeamEventEditScreenComponent_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetCalendarEventEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WidgetCalendarOverview",
        "kind": "LinkedField",
        "name": "widgetCalendarOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": "calendars(includeExternal:true)"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "startAt",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "endAt",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDayEvent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "storeCalendar",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98013bf592f84eda60d727f75ca10005",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarEventEditScreenQuery",
    "operationKind": "query",
    "text": "query WidgetCalendarEventEditScreenQuery(\n  $widgetId: ID!\n  $eventId: ID!\n) {\n  widgetCalendarOverview(id: $widgetId) {\n    calendars(includeExternal: true) {\n      ...CalendarTeamEventEditScreenComponent_storeCalendars\n      id\n    }\n    id\n  }\n  store {\n    timezone\n    calendarEvent(id: $eventId) {\n      ...CalendarTeamEventEditScreenComponent_event\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  isExternal\n}\n\nfragment CalendarTeamEventEditComponent_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  ...CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars\n}\n\nfragment CalendarTeamEventEditScreenComponent_event on CalendarEvent {\n  id\n  title\n  startAt {\n    isoString\n  }\n  endAt {\n    isoString\n  }\n  isAllDayEvent\n  storeCalendar {\n    id\n    isExternal\n  }\n}\n\nfragment CalendarTeamEventEditScreenComponent_storeCalendars on StoreCalendar {\n  ...CalendarTeamEventEditComponent_storeCalendars\n}\n"
  }
};
})();

(node as any).hash = "84d6fc665cb5e6af0edd58003bc76ba9";

export default node;
